import { localize } from '/druid/localization/Localize';
import * as hooks from '/druid/hooks';
import ActivityMiddleware, { ActivityComponentFactory } from '/druid/types/ActivityMiddleware';
import AttachmentForScreenReaderMiddleware, {
  AttachmentForScreenReaderComponentFactory
} from '/druid/types/AttachmentForScreenReaderMiddleware';
import AttachmentMiddleware, { RenderAttachment } from '/druid/types/AttachmentMiddleware';
import AvatarMiddleware, { AvatarComponentFactory } from '/druid/types/AvatarMiddleware';
import CardActionMiddleware, { PerformCardAction } from '/druid/types/CardActionMiddleware';
import Composer, { ComposerProps } from '/druid/hooks/Composer';
import concatMiddleware from '/druid/hooks/middleware/concatMiddleware';
import defaultStyleOptions from '/druid/defaultStyleOptions';
import GroupActivitiesMiddleware, { GroupActivities } from '/druid/types/GroupActivitiesMiddleware';
import normalizeStyleOptions from '/druid/normalizeStyleOptions';
import ScrollToEndButtonMiddleware, { ScrollToEndButtonComponentFactory } from '/druid/types/ScrollToEndButtonMiddleware';
import StyleOptions, { StrictStyleOptions } from '/druid/StyleOptions';
import ToastMiddleware, { RenderToast } from '/druid/types/ToastMiddleware';
import TypingIndicatorMiddleware, { RenderTypingIndicator } from '/druid/types/TypingIndicatorMiddleware';
import WebSpeechPonyfill from '/druid/types/WebSpeechPonyfill';
import WebSpeechPonyfillFactory from '/druid/types/WebSpeechPonyfillFactory';

import type { ActivityStatusMiddleware, RenderActivityStatus } from '/druid/types/ActivityStatusMiddleware';

export { Composer, concatMiddleware, defaultStyleOptions, hooks, localize, normalizeStyleOptions };

export type {
  ActivityComponentFactory,
  ActivityMiddleware,
  ActivityStatusMiddleware,
  AttachmentForScreenReaderComponentFactory,
  AttachmentForScreenReaderMiddleware,
  AttachmentMiddleware,
  AvatarComponentFactory,
  AvatarMiddleware,
  CardActionMiddleware,
  ComposerProps,
  GroupActivities,
  GroupActivitiesMiddleware,
  PerformCardAction,
  RenderActivityStatus,
  RenderAttachment,
  RenderToast,
  RenderTypingIndicator,
  ScrollToEndButtonComponentFactory,
  ScrollToEndButtonMiddleware,
  StrictStyleOptions,
  StyleOptions,
  ToastMiddleware,
  TypingIndicatorMiddleware,
  WebSpeechPonyfill,
  WebSpeechPonyfillFactory
};
